<template>
    <div class="min-vw-100 min-vh-100 d-flex justify-content-center align-items-center">
        <h1 class="display-1 text-primary border-right pr-3">404</h1>
        <h5 class="pl-3">Nie znaleziono strony</h5>
    </div>
</template>

<script>
export default {

}
</script>
